<template>
  <div>
      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; font-size: 14px;" :flat='true'>
    <!-- <v-card class="main-container"> -->
        <v-card-text>
          <template v-if="is_moderator">
              <v-btn
                  @click="uploadToExcel()"
                  x-small style="margin-left: 15px;">
              <v-badge x-small color="#15336d">
                загрузить в * excel
              </v-badge>
            </v-btn>
          </template>

            <v-data-table
                v-model="selected_users"
                :style="{color: $mainColor}"
                :headers="current_headers"
                :items="listUsers"
                :loading="preloaderYet"
                loading-text="Загрузка списка заявок ..."
                :items-per-page="100"
                :footer-props="{
                    itemsPerPageOptions: [20, 100, 500],
                    itemsPerPageText: 'кол-во на стр.:',
                }"
            >
            <template v-slot:body="{ items, isSelected, select}">
              <tbody v-if="is_moderator">
                <tr v-for="item in items" :key="item.id" :class="row_classes(item)">
                  <td>
                    <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                    {{ item.user_descr }}
                    </span>
                  </td>
                  <td>
                    <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                      {{ item.organization_id == 134 ? 'Другая: ' + item.other_org_descr : item.organisation }}
                    </span>
                  </td>
                  <td>
                    <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                      {{ item.confirm_type > 0 ? get_type_descr(item.confirm_type) : get_type_descr(item.type) }}
                    </span>
                  </td>
                  <td v-if="is_moderator">
                    <v-tooltip left v-if="item.file_id > 0">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="openFile(item.file)">
                            mdi-file
                            </v-icon>
                        </template>
                        <span>тезисы</span>
                    </v-tooltip>
                  </td>
                  <td v-if="is_moderator">
                    <v-tooltip left v-if="item.file_pdf_id > 0">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="openFile(item.file_pdf)">
                            mdi-file
                            </v-icon>
                        </template>
                        <span>тезисы pdf</span>
                    </v-tooltip>
                  </td>
                  <td v-if="is_moderator">
                    <v-tooltip left v-if="item.exp_file_id > 0">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="openFile(item.exp_file)">
                            mdi-file-key-outline
                            </v-icon>
                        </template>
                        <span>экспертное заключение</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                  <tr v-for="item in items" :key="item.id" :class="row_classes(item)">
                    <td>
                      <span>
                      {{ item.user_descr }}
                      </span>
                    </td>
                    <td>
                      <span>
                        {{ item.organization_id == 134 ? item.other_org_descr : item.organisation }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
        </v-card-text>

    </v-card>

    <v-dialog v-model="dialogUserCard" width="75%">
      <v-card class="main-card">
        <v-card-title text-color="#15336d">
            <v-icon left color="#15336d">mdi-label</v-icon>
            ID:{{ user_meeting_data.id }}
            {{ user_meeting_data.user_descr }}

        </v-card-title>
        <div class="d-flex flex-nowrap justify-space-between">
          
          <div style="width:50%;">
            <v-card-text style="margin-bottom: 15px; margin-left: 15px;">

                <v-card class="pa-2">
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Организация: </b> {{ user_meeting_data.organisation }}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Телефон: </b> {{ user_meeting_data.phone_number }}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>E-mail: </b> {{ user_meeting_data.email }}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Дата рождения: </b> {{ g.toDate(user_meeting_data.birth_date) }}</p>
                  <v-spacer></v-spacer>
                  <div class="pt-3"></div>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Дата регистрации: </b> {{ g.toDate(user_meeting_data.created_at) }}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Формат участия: </b> {{ user_meeting_data.type == 1 ? 'Слушатель' : (user_meeting_data.type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом')}}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Секция: </b> {{ section_descr(user_meeting_data.section_choice_id) }}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Название доклада: </b> {{ user_meeting_data.comments }}</p>
                    <p style="margin-bottom: 0px; font-size: 16px;"><b>Планирует присутствовать: </b></p>
                    <p  v-for="rec in selected_listen_sections" style="margin-left: 10px; margin-bottom: 0px; font-size: 16px;">{{ '  - ' }} {{ section_descr(rec) }}</p>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text
                      @click="show_attendance(user_meeting_data.id)">{{"Посещаемость"}}
                    </v-btn>
                  </v-card-actions>

                </v-card>

              <v-spacer></v-spacer>
              <div></div>
            </v-card-text>
          </div>

          <div style="width:50%;" class="suggested pr-2">        
            <v-card-text>
                <v-card class="pa-2">
                  <div v-if="user_meeting_data.type > 1">
                    <p style="margin-bottom: 0px; font-size: 16px;"><b>Формат от модератора: </b> {{ user_meeting_data.moder_type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом' }}</p>
                    <p style="margin-bottom: 0px; font-size: 16px;"><b>Секция от модератора: </b> {{ section_descr(user_meeting_data.section_moder_id) }}</p>
                  </div>
                  <div v-if="edit_mode">
                    <v-card-text>
                      <div class="input-container input-name modal-mul-select">
                        <v-select
                          v-model="new_user_type"
                          :items="user_types"
                          item-text="name"
                          item-value="id"
                          outlined
                          chips
                          required
                        ></v-select>
                      </div>
                    </v-card-text>

                    <v-card-text class="pt-0 pb-0" v-if="new_user_type > 1">
                      <div class="input-container input-name modal-mul-select">
                        <v-select
                          v-model="new_section"
                          :items="all_sections"
                          item-text="name"
                          item-value="id"
                          outlined
                          chips
                          required
                        ></v-select>
                      </div>
                    </v-card-text>
                    <v-card-text class="pt-0 pb-0" v-if="new_user_type > 1">
                      <v-text-field
                        v-model="new_org_comment"
                        outlined
                        required
                        name="input-7-4"
                        label="Дата выступления"
                      ></v-text-field>
                    </v-card-text>
                    <v-row  v-if="new_user_type > 1">
                      <v-col cols="4">
                        <v-card-text class="pt-0 pb-0">
                          <v-text-field
                            v-model="new_speak_day"
                            outlined
                            required
                            label="День"
                          ></v-text-field>
                        </v-card-text>
                      </v-col>
                      <v-col cols="4">
                        <v-card-text class="pt-0 pb-0">
                          <v-text-field
                            v-model="new_speak_track"
                            outlined
                            required
                            label="Трек"
                          ></v-text-field>
                        </v-card-text>
                      </v-col>
                      <v-col cols="4">
                        <v-card-text class="pt-0 pb-0">
                          <v-text-field
                            v-model="new_speak_slot"
                            outlined
                            required
                            label="Слот"
                          ></v-text-field>
                        </v-card-text>
                      </v-col>
                    </v-row>

                  </div>
                  <div v-else>
                    <div v-if="user_meeting_data.confirm_type > 1">
                      <p style="margin-bottom: 0px; font-size: 16px;"><b>Подтвержденный формат участия: </b> {{ user_meeting_data.confirm_type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом' }}</p>
                      <p style="margin-bottom: 0px; font-size: 16px;"><b>Секция: </b> {{ section_descr(user_meeting_data.section_confirm_id) }}</p>
                      <p style="font-size: 16px;"><b>Дата выступления: </b> {{ (user_meeting_data.org_comment && user_meeting_data.org_comment.length > 0) ? user_meeting_data.org_comment : 'нет информации'}}</p>
                      <p style="font-size: 16px;"><b>День: </b> {{ (user_meeting_data.speak_day && user_meeting_data.speak_day > 0) ? user_meeting_data.speak_day : '-'}}<b> Трек: </b> {{ (user_meeting_data.speak_track && user_meeting_data.speak_track > 0) ? user_meeting_data.speak_track : '-'}}<b>  Слот: </b> {{ (user_meeting_data.speak_slot && user_meeting_data.speak_slot > 0) ? user_meeting_data.speak_slot : '-'}}</p>
                    </div>
                    <div v-else>
                      <p style="margin-bottom: 0px; font-size: 16px;"><b>Подтвержденный формат участия: </b> {{ user_meeting_data.confirm_type == 1 ? 'Слушатель' : 'нет информации' }}</p>
                    </div>
                    <p style="margin-bottom: 0px; font-size: 16px;"><b>Пользователь подтвердил участие: </b> {{ user_meeting_data.is_confirm ? 'Да' : 'Нет' }}</p>
                  </div>

                  <div class="pt-3"></div>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!edit_mode" color="red darken-1" text @click="edit_mode = true">Изменить</v-btn>
                    <v-btn v-if="edit_mode"  color="red darken-1" text @click="edit_mode = false">Отмена</v-btn>
                    <v-btn v-if="edit_mode"  color="green darken-1" text
                      @click="change_usermeeting()">{{"Сохранить"}}
                    </v-btn>
                  </v-card-actions>

                </v-card>                
            </v-card-text>
                

          </div>

        </div>

      </v-card>

    </v-dialog>

    <v-dialog v-model="attendanceCard" width="65%">
      <v-card class="main-card">
        <v-card-title text-color="#15336d">
            <v-icon left color="#15336d">mdi-label</v-icon>
            ID:{{ user_meeting_data.id }}
            {{ user_meeting_data.user_descr }}

        </v-card-title>
        <div class="d-flex flex-nowrap justify-space-between">
          <v-card class="pa-2 pb-0">
            <v-data-table
                :style="{color: $mainColor}"
                :headers="attendance_headers"
                :items="listAttendance"
                :loading="preloaderYet"
                loading-text="Загрузка списка ..."
                :items-per-page="50"
                :footer-props="{
                    itemsPerPageOptions: [50, 100, 500],
                    itemsPerPageText: 'кол-во на стр.:',
                }"
            >
              <template v-slot:item.created_at="{ item }">
                <p>{{  formate_datetime(item.created_at) }}</p>
              </template>

            </v-data-table>

          </v-card>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="attendanceCard = false">Close</v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>

  </div>
</template>


<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';

  export default {
    name: 'ModeratorTab2',
    components: {
    },
    data() {
      return {
        requests: [],
        listUsers: [],
        preloaderYet: false,
        disabledLoadYet: false,
        selected_users: [],

        current_index: 0,
        cur_meeting_id: 4,
        currentProposal: [],
        listRequestFormat: [],
        checkedItemTable: false,
        current_headers: [],
        is_moderator: false,
        headers: [
            { text: 'ФИО', sortable: true, value: 'user_descr'},
            { text: 'Организация', sortable: true, value: 'organisation'},
        ],
        full_headers: [
            { text: 'ФИО', sortable: true, value: 'user_descr'},
            { text: 'Организация', sortable: true, value: 'organisation'},
            { text: 'Формат участия', sortable: true, value: 'confirm_type'},
            { text: '', value: 'actions', sortable: false},
            { text: '', value: 'actions1', sortable: false},
            { text: '', value: 'actions2', sortable: false}
        ],

        user_meeting_data: {},
        dialogUserCard: false,
        user_types: [
            {id: 1, name : 'Слушатель (без доклада)'},
            {id: 2, name : 'Участник с устным докладом'},
            {id: 3, name : 'Участник со стендовым докладом'},
        ],
        edit_mode: false,
        new_user_type: 1,
        new_section: 0,
        new_org_comment: '',
        new_speak_day: null,
        new_speak_track: null,
        new_speak_slot: null,
        current_id: null,
        active_sections_list: {},
        all_sections: [],
        selected_listen_sections: [],

        attendanceCard: false,
        attendance_headers: [
            { text: 'Section', sortable: true, value: 'section_descr'},
            { text: 'created_at', sortable: true, value: 'created_at'},
        ],
        listAttendance: [],

    };
    },
    beforeMount() {
      this.loadNewRequest();
      this.current_headers = this.headers;
    },

    mounted() {
      this.update_section_list()
    },

 
    computed: {
      ...mapGetters([
        'GETTERS_LOGIN',
        'GETTERS_CURRENT_USER',
        'GETTERS_CURRENT_TUB',
        'GETTERS_SECTIONS',
      ]),
    },

    methods: {
      ...mapActions([
        'GET_USER_ALL',
        'GET_LIST_USER_MEETING',
        'GET_ADMIN_LIST_USER_MEETING',
        'UPLOAD_LIST_TO_EXCEL',
        'UPLOAD_LIST_TO_DOCX',
        'CHANGE_USERMEETING',
        'GET_ATTENDANCE_LIST',
      ]),
      ...mapMutations([
        'UPDATE_OVERLAY',
        'UPDATE_BASE_PROPOSAL_ID',
      ]),

      formate_datetime(val){
        var date_obj = new Date(val)
        var month = date_obj.getMonth() + 1
        var date = date_obj.getDate()
        var m = date_obj.getMinutes()
        var h = date_obj.getHours()
        if (h<10) h = '0'+h
        if (m<10) m = '0'+m
        if (month<10) month = '0' + month
        if (date<10) date = '0' + date

        return date + '.' + month + '.' + date_obj.getFullYear() + ' ' + h + ':' + m
      },

      get_type_descr(id){
        if(id == 2)
          return 'Устно'
        else if(id == 3)
          return 'Стенд'
        else if(id == 1)
          return 'Слушатель'
        else
          return null
      },

      show_attendance(um_id){
        this.preloaderYet = true
        this.listAttendance = [];

        this.UPDATE_OVERLAY(true)
        this.GET_ATTENDANCE_LIST({type: 'person', um_id: um_id})
          .then((res) => {
            this.preloaderYet = false;
            this.listAttendance = res;
            
            this.UPDATE_OVERLAY(false)
          })
          .catch(() => {
            this.UPDATE_OVERLAY(false)
            this.preloaderYet = false
          });

        this.attendanceCard = true
      },

      update_permissions(){
        this.current_headers = this.headers
        if (this.GETTERS_CURRENT_USER !== null) {
          try {
            for (var index = 0; index < this.GETTERS_CURRENT_USER.role.length; index++) {
              const element = this.GETTERS_CURRENT_USER.role[index];

              if (element.access_rights == 'moderator' || element.access_rights == 'conf_admin') {
                this.is_moderator = true;
              }
            }
            if(this.is_moderator)
              this.current_headers = this.full_headers

          } catch (ex) {
            console.log('ex ---> ', ex);
          }
        }
      },

      loadNewRequest(index = 0) {
        const stop = false
        this.current_index = index
  
        this.preloaderYet = true;
        this.disabledLoadYet = false;
        this.listUsers = [];

        this.update_permissions()

        if(this.$route.path == '/users-list-23'){
          this.cur_meeting_id = 1
        }
        else if(this.$route.path == '/users-list-24'){
          this.cur_meeting_id = 2
        }
        else if(this.$route.path == '/users-list-25'){
          this.cur_meeting_id = 3
        }
        else{
          this.cur_meeting_id = 4
        }

        if(this.is_moderator && this.cur_meeting_id == 4){
          this.GET_ADMIN_LIST_USER_MEETING({meeting_id: this.cur_meeting_id, type: 'admin'})
            .then((res) => {
              this.preloaderYet = false;
              this.disabledLoadYet = true;
              this.listUsers = res;
              this.current_headers = this.full_headers
            })
            .catch(() => this.preloaderYet = false);
        }
        else{  
          this.GET_LIST_USER_MEETING({meeting_id: this.cur_meeting_id})
            .then((res) => {
              this.preloaderYet = false;
              this.disabledLoadYet = true;
              this.listUsers = res;
              this.current_headers = this.headers
            })
            .catch(() => this.preloaderYet = false);
        }
      },

      section_descr(id){
        if(id > 0)
          if(this.active_sections_list[id])
            return this.active_sections_list[id].name
          else
            return 'Секция не найдена в справочнике'
        else
          return 'Не указано при регистрации!'
      },

      update_section_list(){
        this.all_sections = []
        this.GETTERS_SECTIONS.forEach((item) => {
          // if(item.is_active && item.is_public){
            this.all_sections.push(item)
          // }
          this.active_sections_list[item.id] = item
        })

      },

      uploadToExcel() {
        this.UPDATE_OVERLAY(true)
        this.UPLOAD_LIST_TO_EXCEL({type: 'admin'})
          .then((res) => {
            this.UPDATE_OVERLAY(false)
            window.open(res.url, '_blank');
          })
          .catch((e) => {
            this.UPDATE_OVERLAY(false)
          });
      },

      change_usermeeting(){
        var data = {
          type: 'admin_change',
          id: this.current_id,
          new_user_type: this.new_user_type,
          new_section: null,
          new_org_comment: '',
          new_speak_day: null,
          new_speak_slot: null,
          new_speak_track: null,
        }
        if(this.new_user_type > 1){
          data.new_org_comment = this.new_org_comment
          data.new_section = this.new_section
          data.new_speak_day = this.new_speak_day
          data.new_speak_slot = this.new_speak_slot
          data.new_speak_track = this.new_speak_track
        }
        this.UPDATE_OVERLAY(true)
        this.CHANGE_USERMEETING(data)
          .then((res) => {
            this.UPDATE_OVERLAY(false)
            this.edit_mode = false
            this.loadNewRequest();
            this.openDetailInfo(this.current_id)
          })
          .catch(() =>{
            this.edit_mode = false
            this.UPDATE_OVERLAY(false)
          });
      },

      openFile(fileName) {
        window.open(`https://api.kcsni-service.ru/media/${fileName}`, '_blank')
      },

      async openDetailInfo(id) {
        this.UPDATE_OVERLAY(true)
        this.GET_USER_ALL(id)
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          this.current_id = id
          this.user_meeting_data = res
          this.new_section = this.user_meeting_data.confirm_type > 0 ? this.user_meeting_data.section_confirm_id : this.user_meeting_data.section_choice_id 
          this.new_org_comment = this.user_meeting_data.org_comment ? this.user_meeting_data.org_comment : '' 
          this.new_speak_day = this.user_meeting_data.speak_day 
          this.new_speak_slot = this.user_meeting_data.speak_slot 
          this.new_speak_track = this.user_meeting_data.speak_track 
          if(this.user_meeting_data.confirm_type > 0){
            this.new_user_type = this.user_meeting_data.confirm_type
          }
          else{
            this.new_user_type = this.user_meeting_data.type
          }
          

          this.selected_listen_sections = []
          var ls = []
          if(this.user_meeting_data.listen_sections !== null)
            ls = this.user_meeting_data.listen_sections.split(', ')
          ls.forEach((item) => {
            this.selected_listen_sections.push(parseInt(item))
          })




          this.dialogUserCard = true
        })
        .catch(() =>{
          this.UPDATE_OVERLAY(false)
        });
      },
      
      row_classes(item) {
        if(this.is_moderator){
          if(item.is_confirm)
            return "green_bg";
          else if(item.confirm_type == 0)
            return "yellow_bg";
          else
            return "white_bg";
        }
        else
          return "white_bg";

      },  
    },

    watch: {
      GETTERS_SECTIONS(val) {
        this.update_section_list()
      },

      GETTERS_CURRENT_USER(val){
        this.loadNewRequest()
      },


      GETTERS_CURRENT_TUB(val) {
        if(val == '/users-list-23'){
          this.cur_meeting_id = 1
        }
        else if(val == '/users-list-24'){
          this.cur_meeting_id = 2
        }
        else if(val == '/users-list-25'){
          this.cur_meeting_id = 3
        }
        else{
          this.cur_meeting_id = 4
        }

        this.loadNewRequest();
      },
    },
  };

</script>
<style scoped>

.green_bg {
  background-color: #93e093;
}
.yellow_bg {
  background-color: #ede84d;
}
.white_bg {
  background-color: rgb(255, 255, 255);
}
.green-bg {
  /* `!important` is necessary here because Vuetify overrides this */
  display: table-row;
  background: rgb(106, 246, 106) !important; 
}

.main-container{
    border-radius: 13px!important;
}
.headline{
    font-size: 12px;
  }
.btn-load-more{
    color: rgb(22, 51, 110);
    border-radius: 0px;
    box-shadow: none;
    margin-bottom: -26px;
    width: 100%;
    z-index: 1;
}
.v-card{
  margin-bottom: 30px;
    border: 0px;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    letter-spacing: 0.5px;
    border-radius: 13px;
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,0.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,0.05);
}

</style>
<style>
.v-application .v-tabs-slider-wrapper {
    color: #15336d !important;
}
</style>